/**
* Featured People Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured People Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-people-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-people-slider' ).each( function( key, component ) {
        const totalSlides = $( component ).find( '.splide__slide' ).length;
        const splide = new Splide( $( component ).find( '.splide--featured-people-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          perMove: 1,
          perPage: 1,
          gap: '35vw',
          focus: 'center',
          speed: 500,
          autoWidth: false,
          keyboard: true,
        } );

        splide.mount();

        splide.on( 'move', function( newIndex, oldIndex, destIndex ) {
          const slides = splide.Components.Elements.slides;

          // Reset classes on all slides
          slides.forEach( function( slide ) {
            slide.classList.remove( 'is-custom-prev', 'is-custom-active', 'is-custom-next' );
          } );

          // Calculate indexes considering loop mode
          const totalSlides = slides.length;
          const prevIndex = ( newIndex - 1 + totalSlides ) % totalSlides;
          const nextIndex = ( newIndex + 1 ) % totalSlides;

          // Apply classes to the slides
          slides[prevIndex].classList.add( 'is-custom-prev' );
          slides[newIndex].classList.add( 'is-custom-active' );
          slides[nextIndex].classList.add( 'is-custom-next' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-people-slider', COMPONENT );
} )( app );
